import { Component, ElementRef, Input, OnInit, Renderer2, ViewChild, AfterViewInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'q-comp-number-range',
  templateUrl: './number-range.component.html',
  styleUrls: ['./number-range.component.css']
})
export class NumberRangeComponent implements OnInit, AfterViewInit, OnChanges {

  constructor(
    private renderer: Renderer2,
  ) { }

  @Input() public minValue: number = 0;
  @Input() public maxValue: number = 0;
  @Input() public lowValue: number = 0;
  @Input() public highValue: number = 0;




  public lowSet: boolean;
  public highSet: boolean;

  @Output('numberRange') emitter: EventEmitter<Array<number>> = new EventEmitter<Array<number>>();

  @ViewChild('progress') progress!: ElementRef;
  private valueGap = 10;


  private debounceTime: number = 700;

  ngOnInit(): void { 
  }

  ngAfterViewInit(): void {
    this.valueGap = (this.maxValue - this.minValue) * 2 / 100
    this.setProgressStyle();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.progress) {
      this.setProgressStyle();
    }


    this.highSet = changes['highValue'].currentValue != 0;
    this.lowSet = changes['lowValue'].currentValue != 0;
  }


  changeInput(isLowValue: boolean = false) {
    if (isLowValue) {
      this.lowSet = true;
      if (!this.highSet) {
        this.highSet = true;
        this.highValue = this.maxValue;
      }
      this.lowValue = this.clamp(this.lowValue, this.minValue, this.maxValue);
    } else {
      this.highSet = true;
      this.highValue = this.clamp(this.highValue, this.minValue, this.maxValue);
    }

    if (this.lowValue > this.highValue) {
      let value: number = this.highValue;
      this.highValue = this.lowValue;
      this.lowValue = value;
    }

    this.emitData();
    this.setProgressStyle();
  }

  changeRange(isLowValue: boolean = false) {
    /* if ((this.highValue - this.lowValue) < 0) {
       if (isLowValue) {
         this.lowValue = this.highValue - 0;
       } else {
         this.highValue = this.lowValue + 0;
       }
     }*/

    if (isLowValue) {
      this.lowSet = true;
    } else {
      this.highSet = true;
    }

    this.emitData();
  }


  deleteValue(isLowValue: boolean = false) {
    if (isLowValue) {
      this.lowValue = 0;
      this.lowSet = false;
    } else {
      this.highValue = 0;
      this.highSet = false;
    }

    this.emitData();
  }


  limitValue(event: any, isLowValue: boolean = false) {
    if (isLowValue) {
      event.currentTarget.value = this.lowValue.toString();
    } else {
      event.currentTarget.value = this.highValue.toString();
    }

    this.setProgressStyle();
  }


  private emitData() {

    if (this.lowValue == this.minValue) {
      this.lowSet = false;
    }

    if (this.highValue == this.minValue /*+ this.valueGap*/) {
      this.highSet = false;
    }

    this.setProgressStyle();
    this.emitter.emit([this.lowSet ? this.lowValue : -1, this.highSet ? this.highValue : -1]);
  }

  public setProgressStyle() {
    let left = ((this.lowValue / this.maxValue) * 100);
    let right = (100 - (this.highValue / this.maxValue) * 100);

    if (this.lowValue > this.highValue) {
      left = ((this.highValue / this.maxValue) * 100);
      right = (100 - (this.lowValue / this.maxValue) * 100);
    }

    this.renderer.setStyle(this.progress.nativeElement, 'left', `${this.clamp(left,0,100)}%`);
    this.renderer.setStyle(this.progress.nativeElement, 'right', `${this.clamp(right, 0, 100)}%`);
  }


  private clamp(val: number, min: number, max: number) {
    return (val < min) ? min : (val > max) ? max : val;
  }
}
